"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chart_sort_type_model_1 = require("./chart-sort-type.model");
const Subject_1 = require("rxjs/Subject");
const measure_model_1 = require("../../../shared/model/measure.model");
/**
 * Created by mariam.melkonyan on 5/18/17.
 */
class CategoricalChartReportModel {
    constructor() {
        /**
         * The row category id of the chart
         * @private
         */
        this._category = null;
        /**
         * The series category id of the chart
         * @type {number}
         * @private
         */
        this._series = null;
        /**
         * The list of measues of the chart
         * @type {Array.<MeasureModel>}
         * @private
         */
        this._measures = [];
        /**
         * The top count of the report data that should be shown in chart
         * @type {number}
         * @private
         */
        this._top = 10;
        /**
         * The top count of the report series data that should be shown in chart
         * @type {number}
         * @private
         */
        this._seriesTop = 10;
        /**
         * The Sort Type for Chart (it can be according the category or values: ascending/descending)
         * @type {ChartSortType}
         * @private
         */
        this._chartSortType = chart_sort_type_model_1.ChartSortType.CATEGORY_ASCENDING;
        this._excludeUnspecified = false;
        /**
         * Subject for emitting report model changes.
         * @type {Subject<void>}
         */
        this._reportModelSubject = new Subject_1.Subject();
    }
    get category() {
        return this._category;
    }
    set category(category) {
        this._category = category;
        this._reportModelSubject.next();
    }
    get series() {
        return this._series;
    }
    set series(series) {
        this._series = series;
        this._reportModelSubject.next();
    }
    get measures() {
        return this._measures;
    }
    set measures(measures) {
        this._measures = measures;
        this._reportModelSubject.next();
    }
    get top() {
        return this._top;
    }
    set top(top) {
        this._top = top;
        this._reportModelSubject.next();
    }
    get seriesTop() {
        return this._seriesTop;
    }
    set seriesTop(top) {
        this._seriesTop = top;
        this._reportModelSubject.next();
    }
    get chartSortType() {
        return this._chartSortType;
    }
    set chartSortType(chartSortType) {
        this._chartSortType = chartSortType;
        this._reportModelSubject.next();
    }
    setChartSortType(chartSortType) {
        this._chartSortType = chartSortType;
    }
    get excludeUnspecified() {
        return this._excludeUnspecified;
    }
    set excludeUnspecified(excludeUnspecified) {
        this._excludeUnspecified = excludeUnspecified;
    }
    /**
     * Returns an observale that emits every time the report model is changed.
     * @returns {Observable<void>}
     */
    getChartReportModel() {
        return this._reportModelSubject;
    }
    /**
     * Serializes the chart report model to json object
     * @returns {any}
     */
    serialize() {
        let jsonObject = {};
        jsonObject.category = this.category;
        jsonObject.series = this.series;
        jsonObject.measures = this.measures;
        jsonObject.chartSortType = this.chartSortType;
        jsonObject.excludeUnspecified = this.excludeUnspecified;
        jsonObject.top = this.top;
        jsonObject.seriesTop = this.seriesTop;
        return jsonObject;
    }
    /**
     * Deserializes the categorical chart model from json object and emits change event.
     * @param jsonObject
     */
    deserialize(jsonObject) {
        this._category = jsonObject.category === undefined ? null : jsonObject.category;
        this._series = jsonObject.series === undefined ? null : jsonObject.series;
        this._measures = jsonObject.measures == undefined ? null :
            jsonObject.measures
                .map(measure => measure_model_1.MeasureModel.fromJSON(measure));
        this._chartSortType = jsonObject.chartSortType == null ? chart_sort_type_model_1.ChartSortType.CATEGORY_ASCENDING : jsonObject.chartSortType;
        this._excludeUnspecified = jsonObject.excludeUnspecified === undefined ? false : jsonObject.excludeUnspecified;
        this._top = jsonObject.top === undefined ? 10 : jsonObject.top;
        this._seriesTop = jsonObject.seriesTop === undefined ? (jsonObject.top === undefined ? 10 : jsonObject.top) : jsonObject.seriesTop;
        this._reportModelSubject.next();
    }
    /**
     * These method check if generated report is valid
     * @returns {boolean}
     */
    validateReport() {
        return (this.category !== null && this.measures.length > 0);
    }
}
exports.CategoricalChartReportModel = CategoricalChartReportModel;
//# sourceMappingURL=categorical-chart-report.model.js.map